var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuspend = function SvgSuspend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM13.5 11C13.5 10.0795 12.7538 9.33333 11.8333 9.33333C10.9129 9.33333 10.1667 10.0795 10.1667 11V21C10.1667 21.9205 10.9129 22.6667 11.8333 22.6667C12.7538 22.6667 13.5 21.9205 13.5 21V11ZM21.8333 11C21.8333 10.0795 21.0871 9.33333 20.1667 9.33333C19.2462 9.33333 18.5 10.0795 18.5 11V21C18.5 21.9205 19.2462 22.6667 20.1667 22.6667C21.0871 22.6667 21.8333 21.9205 21.8333 21V11Z",
    fill: "currentColor"
  })));
};
export default SvgSuspend;